export const SET_LIST_GROUPS = 'groups/SET_LIST_GROUPS';
export const ADD_GROUP = 'groups/ADD_GROUP';
export const GET_GROUP = 'groups/GET_GROUP';
export const SET_GROUP = 'groups/SET_GROUP';
export const GET_LIST_GROUPS = 'groups/GET_LIST_GROUPS';
export const EDIT_GROUP = 'groups/EDIT_GROUP';
export const GET_GROUP_PERMISSION = 'groups/GET_GROUP_PERMISSION';
export const SET_GROUP_PERMISSION = 'groups/SET_GROUP_PERMISSION';
export const UPDATE_GROUP_PERMISSION = 'groups/UPDATE_GROUP_PERMISSION';
export const DELETE_GROUP = 'groups/DELETE_GROUP';

export default {
	SET_LIST_GROUPS,
	ADD_GROUP,
	GET_GROUP,
	SET_GROUP,
	GET_LIST_GROUPS,
	EDIT_GROUP,
	GET_GROUP_PERMISSION,
	SET_GROUP_PERMISSION,
	UPDATE_GROUP_PERMISSION,
	DELETE_GROUP,
};
